module.exports = function(cb) {
	require.ensure([], function(require) {
		cb(require("!!./Keypad.js"));
	}, "Keypad");
}